import useFirebase from "../../../../../useFirebase";

function useGeoLocation(
  device,
  locationData,
  setLocationData,
  allFireStoreData
) {
  const { getCollectionData, postCollectionData, createCollectionData } =
    useFirebase();

  function callFireStore(payload) {
    console.log(payload);
    postCollectionData(device, { geoLocationData: payload });
    getCollectionData(device);
  }
  function callFireStoreForEnableDisable(payload) {
    const payload1 = {
      locationgeofendingsettings: {
        geoLocationEnable: payload?.geoLocationEnabled == 1 ? true : false,
      },
    };
    const payload2 = {
      setRulesActiveInActiveStatus: {
        ...allFireStoreData.setRulesActiveInActiveStatus,
        locationAndGeofencingEnable:
          payload?.geoLocationEnabled == 1 ? true : false,
      },
    };
    postCollectionData(device, payload1);

    postCollectionData(device, payload2);
    getCollectionData(device);
  }

  function createCollectionStore(payload) {
    createCollectionData(device, { geoLocationData: payload });
    getCollectionData(device);
  }

  function handleToggleChange(e) {
    const { name, checked } = e.target;
    const collectionPayload = {};

    if (name === "LOCATION_ENABLE") {
      collectionPayload["geoLocationEnabled"] = checked ? 1 : 0;
    }

    callFireStoreForEnableDisable(collectionPayload);
  }

  function addEditData(data) {
    if (locationData?.find((item) => item?.id == data.id)) {
      const collectionPayload = locationData?.map((item) => {
        if (item?.id == data?.id) {
          return data;
        } else return item;
      });
      callFireStore(collectionPayload);
    } else {
      const collectionPayload = [...locationData, data];
      callFireStore(collectionPayload);
    }
  }
  function deleteLocationData(data) {
    const collectionPayload = locationData?.filter((item) => {
      if (item?.id != data?.id) {
        return data;
      }
    });
    callFireStore(collectionPayload);
  }

  return {
    handleToggleChange,
    addEditData,
    deleteLocationData,
  };
}

export default useGeoLocation;
